import { useQuery } from "@tanstack/react-query";
import fetcher from "src/utils/fetcher";
import { useAuth } from "src/components/utils/auth/assist/authContext";

interface InkedBalanceResponse {
  balance: number;
  prices: {
    card: number;
  };
  update_timestamp: string;
}

export interface InkedBalanceData {
  balance: number;
  cardPrice: number;
}

export const useInkedBalance = () => {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: ["inkedBalance", user?.email],
    queryFn: async (): Promise<InkedBalanceData> => {
      const response = await fetcher({
        url: `/api/inked/balance`,
        method: 'GET',
      });

      const data = response.data as InkedBalanceResponse;

      if (data.prices?.card === undefined) {
        throw new Error("Card price not returned from balance API");
      }

      // Values are in cents, Inked handles formatting to dollars
      return {
        balance: data.balance,
        cardPrice: data.prices.card,
      };
    },
    enabled: !!user,
    staleTime: 30000, // Cache for 30 seconds
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  return {
    ...query,
    isFetching: query.isFetching,
  };
};
